<template>
  <div>
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center" style="padding-bottom: inherit;min-heigth:30px;">
      <h4 v-if="showTitle">
        {{$t('users.roles.title')}}
      </h4>
      <div v-if="userHasRoles" class="d-flex justify-content-end search-text-wrapper align-items-center" style="margin-left: auto;">
        <div class="d-flex align-self-center align-items-center">
          <searchable
            :querySearch.sync="querySearch"
            :placeholder="this.$t(`users.roles.${activeComponent.searchPlaceholder}`)"
            :searchTooltip="searchTooltip"
          />
        </div>
        &nbsp;
        <va-popover
          :message="toogleViewsTooltip"
          placement="left">
          <span href="#" class="switch-view-icon clickable" v-if="userHasRoles" @click.prevent="toogleView(activeComponent.id)">
            <i style="font-size: 1.3rem;" class="fa fa-exchange" :class="{'animated': animated}"></i>
          </span>
        </va-popover>
      </div>
    </div>
    <div v-if="userHasRoles">
      <div v-if="isFetchingServer">
        <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
      <div v-else>
        <div v-if="activeComponent.component">
          <transition mode="out-in">
            <component
              v-if="userHasRoles && !error"
              :is="activeComponent.component"
              :roles="userRoles"
              :isViewMode="isViewMode"
              :subRoles="userSubRoles"
              :query="querySearch"
              :editable="editable"
              :limitItems="limitItems !== null ? limitItems : limitItemsByScreenSize"
              :clusters="clusters"
              @updateUserRules="updateUserRules"
              @showEntitiesForRoleModal="showEntitiesForRoleModal"
              @showRolesForEntityModal="showRolesForEntityModal">
            </component>
            <div v-else>
              <span class="d-flex justify-content-center pt-4">
                <b>{{ 'users.roles.' + Object.keys(error)[0] | translate }}</b>
              </span>
            </div>
          </transition>
        </div>
        <div v-else>
          <span class="d-flex justify-content-center pt-4">
            <b>{{ 'users.roles.without' | translate }}</b>
          </span>
        </div>
      </div>

      <div v-show="showLoadingIndicator">
        <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center pt-4 pb-4">
      <b>{{'users.roles.forbidden' | translate}} {{'menu.' + selectedViewService.translateKey | translate}}.</b>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import LoadingAnimation from '../Helpers/LoadingAnimation'
import ViewRolesByEntity from './components/ViewRolesByEntity'
import ViewEntitiesByRole from './components/ViewEntitiesByRole'
import ScreenSizeMixin from '../Helpers/ScreenSizeMixin'
import Multiselect from 'vue-multiselect'
import Searchable from '@/components/common/Searchable'
import EventBus from '@/utils/EventBus'
const authenticationServerRolesEndpoint = '/roles'
const authenticationServerClustersEndpoint = '/clusters'

export default {
  components: {
    LoadingAnimation,
    ViewRolesByEntity,
    ViewEntitiesByRole,
    Multiselect,
    Searchable
  },
  mixins: [
    ScreenSizeMixin
  ],
  props: {
    userId: {
      type: Number,
      required: true
    },
    entityId: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    limitItems: {
      type: Number,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      isFetchingServer: true,
      showLoadingIndicator: false,
      isViewMode: true,
      views: [
        { id: 1, component: 'ViewRolesByEntity', searchPlaceholder: 'search_by_entity' },
        { id: 2, component: 'ViewEntitiesByRole', searchPlaceholder: 'search_by_role' }
      ],
      activeComponent: { id: 2, component: 'ViewEntitiesByRole', searchPlaceholder: 'search_by_role' },
      userRoles: [],
      querySearch: '',
      showQuerySearch: false,
      showQueryButton: true,
      searchTooltip: { content: this.$t('users.roles.search_tooltip'), placement: 'left' },
      selectedViewService: null,
      animated: false,
      error: null,
      userSubRoles: null,
      clusters: []
    }
  },
  mounted () {
    this.showQuerySearch = false
    this.loadClusters()
    EventBus.$on('ENTITY_ACTIVITY_USER_UPDATED', (payload) => {
      this.loadUserRoles()
        .then(userRoles => {
          this.userRoles = userRoles
        }).catch(errors => {
          console.log(errors)
        })
    })
  },
  methods: {
    toogleViewType: function () {
      this.isViewMode = !this.isViewMode
    },
    loadRolesAndSubRoles: function () {
      this.error = null
      this.isFetchingServer = true
      Promise.all([this.loadUserRoles(), this.loadUserSubroles()])
        .then((data) => {
          this.userRoles = data[0]
          this.userSubRoles = data[1]
          this.isFetchingServer = false
        }).catch((err) => {
          this.error = err.response.data
        })
    },
    loadClusters: function (url = `${this.$store.state.evollauth_server}${authenticationServerClustersEndpoint}`) {
      this.$http({ url })
        .then((response) => {
          this.clusters = response.data.data
        }).catch(err => {
          console.log(err)
        })
    },
    loadUserSubroles: function (url = `${this.$store.state.evollauth_server}/users/${this.$auth.user().id}/subroles`) {
      return new Promise((resolve, reject) => {
        this.$http({
          url
        }).then((response) => {
          resolve(response.data.data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    showRolesForEntityModal: function ({ roles, entity }) {
      this.$emit('showRolesForEntityModal', { roles, entity })
    },
    showEntitiesForRoleModal: function ({ entities, role }) {
      this.$emit('showEntitiesForRoleModal', { entities, role })
    },
    filterUserRoles: function () {
      this.showQuerySearch = !this.showQuerySearch
      this.showQueryButton = !this.showQueryButton
      if (this.showQuerySearch) {
        Vue.nextTick(() => {
          this.$refs.inputQuerySearch.focus()
        })
      } else {
        this.querySearch = ''
      }
    },
    toogleView: function (currentViewId) {
      this.activeComponent = this.views.find(view => view.id !== currentViewId)
      this.querySearch = ''
      this.animated = true
      setTimeout(() => {
        this.animated = false
      }, 500)
      this.showQuerySearch = false
      this.showQueryButton = true
    },
    loadUserRoles: function (url = `${this.$store.state.evollauth_server}/users/${this.userId}${authenticationServerRolesEndpoint}`) {
      return new Promise((resolve, reject) => {
        this.$http({ url })
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    updateUserRules: function (payload) {
      this.showLoadingIndicator = true
      this.$http({
        url: this.$store.state.evollauth_server + '/users/' + this.userId + '/roles',
        method: 'POST',
        data: payload
      }).then((response) => {
        setTimeout(() => {
          this.showLoadingIndicator = false
          this.showToast(this.$t('users.roles.updated'), this.$store.state.successToastOptions)
          this.userRoles = response.data.data
          this.$emit('userRolesUpdated', { serviceId: 6 })
        }, 350)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    resetSearch: function () {
      this.showQuerySearch = false
      setTimeout(() => {
        this.showQueryButton = true
        this.querySearch = ''
      }, 500)
    },
    assignPermissionsInfoType: function (service) {
      return 100
    }
  },
  computed: {
    userHasRoles: function () {
      return this.$store.state.services.some(service => service.user_roles.length > 0)
    },
    limitItemsByScreenSize: function () {
      if (this.windowWidth < 768) {
        return 1
      } else if (this.windowWidth < 1024) {
        return 4
      } else if (this.windowWidth < 1280) {
        return 5
      } else {
        return 6
      }
    },
    toogleViewsTooltip: function () {
      return this.activeComponent.id === 1 ? this.$t('users.roles.switch_view_1') : this.$t('users.roles.switch_view_2')
    }
  },
  watch: {
    userId: {
      handler () {
        this.loadRolesAndSubRoles()
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss">
.reset-filter{
  color: #C0C0C0;
  cursor: pointer;
  background-color: white;
}

.reset-search{
  color: #29c4a9;
  position: relative;
  margin-left: -25px;
}

.searchRoles {
  border-radius:20px;
  border-color: #A49D97;
  padding-left:10px;
  border-style: solid;
  padding-right: 18px;
  width: 225px;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  transition: all .5s ease;
}

input.searchRoles{
    outline: none;
    border-color: #29c4a9;
}

.searchRoles::-webkit-outer-spin-button,
.searchRoles::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.search-text-wrapper{
  min-height: 35px;
}

.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 250ms }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 250ms }
.v-enter-to { opacity: 1; }

.search-roles-gone{
  cursor: default;
  visibility: none;
  opacity: 0;
  width: 0;
  animation-name: dissapearAnimation;
  animation-duration: 650ms;
}

@keyframes dissapearAnimation {
  0% {
    width: 225px;
  }
  100% {
    width: 0px;
    display: none;
  }
}

.multiselect .multiselect__tag {
    background-color: #29c4a9;
}
.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

.animated {
  animation: spin 500ms infinite;
}

@keyframes spin {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(180deg);}
}

.modal{
  overflow: auto;
}
</style>

<style scoped lang="scss">
.roles-multiselect{
  width: 350px;
}

@media only screen and (max-width: 768px) {
  .roles-multiselect {
    min-width: 90%;
    max-width: 250px;
  }
}
</style>
